module.exports = __webpack_public_path__ + "img/cases-brand-7.ec22386e.png";